// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  px, mb, mt, p, ml
} from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StyledLabel } from '@styles/labels';
import { StyledButton } from '@styles/buttons';
import theme from '@theme';
import { Checkbox } from '@components';

const { colors } = theme;

export const StyledItem = styled.div`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  flex-direction: ${({ forMobile = true }) => (forMobile ? 'column' : 'row')};
  align-items: center;

  margin-bottom: ${({ forMobile = true }) => (forMobile ? 0 : '1rem')};

  ${breakpoint('desktop')`
    flex-direction: row;
    ${mb(4)}
  `};
`;

export const StyledInputLabelDisplay = styled(StyledLabel)`
  font-weight: 900;
`;

export const StyledInputUnit = styled.div`
  width: 100%;
  ${mb(3)}

  & label {
    margin-left: 0;
  }

  ${breakpoint('desktop')`
    width: 48%;
    ${mb(1)}
  `}
`;

export const StyledSelectContainer = styled.div`
  position: relative;

  width: 100%;

  ${mt(2)}
`;

export const StyledSelectDownCaretIcon = styled(FontAwesomeIcon)`
  margin: 0 10px;

  display: inline-block;
  position: absolute;

  top: 16px;
  right: 10px;

  z-index: 1;

  width: 8px;
`;

export const StyledSelect = styled.select`
  background: ${colors.greyBlue10};
  appearance: none;

  border: none;
  border-radius: 0;

  width: 100%;
  font-size: 1rem;

  ${p(2.5)}

  ${breakpoint('desktop')`
    ${theme.borderRadius.small};
    background: ${colors.white};
  `}
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 0;
`;

export const StyledAgreementTextContainer = styled.div`
  max-width: 40rem;
  
  font-size: 14px;
  line-height: 1.57;
  
  ${ml(3.5)}
  ${mt(1)}
  
  ${breakpoint('desktop')`
    margin-top: 0;
  `}
`;

export const StyledTextWrapper = styled.div`
  margin-bottom: ${({ addMargin }) => (addMargin ? '10px' : '0')};
`;

export const StyledAgreementText = styled.span`
  display: ${({ asBlock }) => (asBlock ? 'block' : 'inline')};
  margin-right: ${({ asBlock }) => (asBlock ? '0' : '3px')};
`;

export const StyledLink = styled.a`
  color: ${colors.darkBlue};
`;

export const StyledSubmitButton = styled(StyledButton)`
  ${mb(6)}
  ${px(4)}

  ${breakpoint('desktop')`
    ${mb(0)}
  `}
`;
